import React, { useState, useEffect } from 'react';
import { useTranslate } from 'react-admin';
import { Box, Typography, Grid } from '@mui/material';

import AchievementCard from './AchievementCard';

import { ACHIEVEMENTS_TIERS } from './achievements';
import { fetchUserStats } from '../../../services/api';


const AchievementsPage = ({ userId }) => {
    const [stats, setStats] = useState();
    const translate = useTranslate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchUserStats(userId);
                if (response) {
                    setStats(response);
                }
            } catch (error) {
                console.error(error);
            }
        };

        if (userId) {
            fetchData();
        }
    }, [userId]);

    return (
        <Box sx={{ p: { xs: 2, md: 3 } }}>
            <Grid container spacing={2.5}>
                <AchievementCard
                    icon="/img/achievements/projects.png"
                    title={translate('More work?')}
                    value={stats?.projects}
                    tiers={ACHIEVEMENTS_TIERS.projects}
                    description={<Typography variant="caption">{translate('Involved in many projects')}</Typography>}
                />
                <AchievementCard
                    icon="/img/achievements/time_entries_days.png"
                    title="Tempus fugit"
                    value={stats?.time_entries?.days}
                    tiers={ACHIEVEMENTS_TIERS.time_entries.days}
                    description={
                        <>
                            <Typography variant="caption" display="block" gutterBottom>{translate('Has filled his timesheet many times')}</Typography>
                            <Typography variant="caption" display="block">{translate('Time is an illusion. Lunchtime doubly so.')}</Typography>
                        </>
                    }
                />
                <AchievementCard
                    icon="/img/achievements/time_entries_meetings.png"
                    title={translate('Pain reinforces devotion')}
                    value={stats?.time_entries?.types?.meeting}
                    tiers={ACHIEVEMENTS_TIERS.time_entries.meetings}
                    description={<Typography variant="caption">{translate('Took part in many meetings')}</Typography>}
                />
                <AchievementCard
                    icon="/img/achievements/communication.png"
                    title={translate('Hang by a thread')}
                    value={stats?.time_entries?.types?.communication}
                    tiers={ACHIEVEMENTS_TIERS.time_entries.communication}
                    description={<Typography variant="caption">{translate('Took part in many calls and discussions')}</Typography>}
                />
                <AchievementCard
                    icon="/img/achievements/prospection.png"
                    title={translate('The nugget')}
                    value={stats?.time_entries?.types?.prospection}
                    tiers={ACHIEVEMENTS_TIERS.time_entries.prospection}
                    description={<Typography variant="caption">{translate('Has done a lot of prospecting')}</Typography>}
                />
                <AchievementCard
                    icon="/img/achievements/dev.png"
                    title={translate('Stack Overflow thief')}
                    value={stats?.time_entries?.types?.development}
                    tiers={ACHIEVEMENTS_TIERS.time_entries.development}
                    description={<Typography variant="caption">{translate('Has done a lot of development')}</Typography>}
                />
                <AchievementCard
                    icon="/img/achievements/design.png"
                    title={translate('2px to the right')}
                    value={stats?.time_entries?.types?.design}
                    tiers={ACHIEVEMENTS_TIERS.time_entries.design}
                    description={<Typography variant="caption">{translate('Has done a lot of design')}</Typography>} // 
                />
                <AchievementCard
                    icon="/img/achievements/documentation.png"
                    title={translate('The scholar')}
                    value={stats?.time_entries?.types?.documentation}
                    tiers={ACHIEVEMENTS_TIERS.time_entries.documentation}
                    description={<Typography variant="caption">{translate('Has done a lot of documentation')}</Typography>}
                />
                <AchievementCard
                    icon="/img/achievements/testing.png"
                    title={translate('For those who come after')}
                    value={stats?.time_entries?.types?.testing}
                    tiers={ACHIEVEMENTS_TIERS.time_entries.testing}
                    description={<Typography variant="caption">{translate('Has done a lot of testing')}</Typography>}
                />
                <AchievementCard
                    icon="/img/achievements/support.png"
                    title={translate('Did you tried turning it off and on again?')}
                    value={stats?.time_entries?.types?.support}
                    tiers={ACHIEVEMENTS_TIERS.time_entries.support}
                    description={<Typography variant="caption">{translate('Has done a lot of support')}</Typography>}
                />
                <AchievementCard
                    icon="/img/achievements/other.png"
                    title={translate('It is by doing whatever that we become whoever')}
                    value={stats?.time_entries?.types?.other}
                    tiers={ACHIEVEMENTS_TIERS.time_entries.other}
                    description={<Typography variant="caption">{translate('Has done a lot of indescribable things')}</Typography>}
                />
                <AchievementCard
                    icon="/img/achievements/leaves_sick.png"
                    title={translate('Disciple of Nurgle')}
                    value={stats?.leaves?.sick}
                    tiers={ACHIEVEMENTS_TIERS.leaves.sick}
                    description={<Typography variant="caption">{translate('Took one day\'s sick leave')}</Typography>}
                />
                <AchievementCard
                    icon="/img/achievements/long_meetings.png"
                    title={translate('Marathoner')}
                    value={stats?.time_entries?.long_meetings}
                    tiers={ACHIEVEMENTS_TIERS.time_entries.long_meetings}
                    description={<Typography variant="caption">{translate('Underwent very long meetings')}</Typography>}
                />
                <AchievementCard
                    icon="/img/achievements/longer_days.png"
                    title="Grenouille de bénitier"
                    value={stats?.time_entries?.longer_days}
                    tiers={ACHIEVEMENTS_TIERS.time_entries.longer_days}
                    description={<Typography variant="caption" display="block" gutterBottom>{translate('Has filled his timesheet many times with more than 8 hours a day')}</Typography>}
                />
                <AchievementCard
                    icon="/img/achievements/all.png"
                    title={translate('The Pretender')}
                    value={stats?.time_entries?.types ? Object.values(stats?.time_entries?.types).reduce((acc, value) => value >= 50 ? acc + 1 : acc, 0) : 0}
                    tiers={ACHIEVEMENTS_TIERS.time_entries.all_types}
                    description={
                        <>
                            <Typography variant="caption" display="block" gutterBottom>{translate('Has filled his timesheet many times in many types of activity')}</Typography>
                            <Typography variant="caption" display="block">{translate('There are Pretenders among us. Geniuses with the ability to become anyone they want to be.')}</Typography>
                        </>
                    }
                />
            </Grid>
        </Box>
    );
};

export default AchievementsPage;
